import {AfterViewInit, Component, OnInit} from '@angular/core';
import {
    ControlService,
    IconService,
    SubtitlesService,
    TimeDateService
} from "../../../core";
import {MenuElementType107, MenuType} from "../../../models";

@Component({
    selector: 'date-picker-control',
    templateUrl: './date-picker-control.component.html',
    styleUrls: ['./date-picker-control.component.scss']
})
export class DatePickerControlComponent implements OnInit, AfterViewInit {
    newDate: string = '';

    constructor(
        public control: ControlService,
        private icon: IconService,
        private subtitles: SubtitlesService,
        public timeDate: TimeDateService,
    ) {
    }

    ngOnInit() {
        const elementVal = this.control.elementVal.getValue() as MenuElementType107;
        const params = elementVal.params;
        if (params) {
            this.newDate = `${params.year}-${this.timeDate.double(params.month)}-${this.timeDate.double(params.day)}`;
        }
        this.timeDate.setDatePicker();
    }

    ngAfterViewInit() {
        this.control.setOverflow();
    }

    setIcon(val: number | MenuType): string {
        if (val === null) return;

        return this.icon.setIcon(val);
    }

    subtitle(val: number): string {
        return val !== 0 ? this.subtitles.setSubtitle(val) : '';
    }

    setDate(date:string): void {
        this.newDate = date;
        this.control.date = date;
    }

    setDateNow(): void {
        this.newDate = this.timeDate.formatDate(new Date());
        this.timeDate.setDateNow();
    }

    setDateFromParams(): void {
        const element = this.control.elementVal.getValue() as MenuElementType107;
        const params = element.params;
        if (params) {
            this.newDate = `${params.year}-${this.timeDate.double(params.month)}-${this.timeDate.double(params.day)}`;
        }
        this.timeDate.setDatePicker();
    }
}
